import { Locale } from "./types";

export function isValidLocale(locale: string): locale is Locale {
  return Object.values(Locale).includes(locale as Locale);
}
